import {useTransition} from '@logistics-frontend/blocks'
import type {ServerError} from '@logistics-frontend/core/utils/network'

import {fetchPromotions} from 'src/api'

import {useSharedRouteInfo} from '../../hooks'
import {stubPromotions, toPromotions} from './AutoBanner.mappers'
import {Promotion} from './AutoBanner.types'

const DELIVERY_PROMOTIONS_KEY = 'route/delivery-promotions'

const stubbedPromotions = stubPromotions()

export const usePromotions = () => {
  const info = useSharedRouteInfo()

  const [{payload: promotions = stubbedPromotions, isPending}] = useTransition<Promotion, ServerError>(
    () =>
      fetchPromotions({
        coordinate: {
          latitude: info?.route_points[0].coordinates[0],
          longitude: info?.route_points[0].coordinates[1],
        },
        screen: {
          type: 'tracking',
          is_shared_route: true,
          order_status: info?.context.provider_status,
          taxi_tariff: info?.context.provider_tariff_class,
        },
      }).then(toPromotions),
    {
      key: DELIVERY_PROMOTIONS_KEY,
    },
  )

  return {
    promotions,
    isPending,
  }
}
